import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Container, Spinner } from "react-bootstrap";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";

const CreateAssets = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Retrieves the ID from the URL if editing
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  const [formData, setFormData] = useState({
    asset_type: "",
    asset_name: "",
    asset_description: "",
    asset_date: "",
    asset_amount: "",
  });

  // 1. Fetch existing data if "id" exists (Edit Mode)
  useEffect(() => {
    if (id) {
      const fetchAssetDetails = async () => {
        setFetching(true);
        try {
          const payload = {
            customer_id: Number(localStorage.getItem("customer_id")) || 1005,
            api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
            user_id: localStorage.getItem("user_id") || 14857,
            asset_id: id // Send ID to get specific asset
          };
          const response = await simplePostCall(ApiConfig.vieweeassets, JSON.stringify(payload));
       
           
            const asset = response.data;
            setFormData({
              asset_type: asset.asset_type,
              asset_name: asset.asset_name,
              asset_description: asset.asset_description,
              asset_date: asset.asset_date.split('T'), // Format date for input
              asset_amount: asset.asset_amount,
            });
     
        } catch (error) {
          toast.error("Failed to load asset details");
        } finally {
          setFetching(false);
        }
      };
      fetchAssetDetails();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 2. Combined Submit Handler (Create OR Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.asset_type || !formData.asset_name || !formData.asset_amount) {
      toast.error("Please fill in all required fields");
      return;
    }

    setLoading(true);
    try {
      const commonPayload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        asset_type: formData.asset_type,
        asset_name: formData.asset_name,
        asset_description: formData.asset_description,
        asset_date: formData.asset_date,
        asset_amount: Number(formData.asset_amount),
      };

      let response;
      if (id) {
        // UPDATE MODE
        const updatePayload = { ...commonPayload, asset_id: id };
        response = await simplePostCall(ApiConfig.Updateassets, JSON.stringify(updatePayload));
      } else {
        // CREATE MODE
        response = await simplePostCall(ApiConfig.createassets, JSON.stringify(commonPayload));
      }

      if (response && response.result) {
        toast.success(id ? "Asset updated successfully" : "Asset created successfully");
        setTimeout(() => navigate("/accountant/finance/asset"), 1500);
      } else {
        toast.error(response.message || "Operation failed");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <div className="text-center mt-5"><ScaleLoader color="#F4BB44" /></div>;

  return (
    <div className="create-wrapper">
      <ToastContainer />
      <Container fluid className="mt-3">
        <div className="title-section mb-4">
          <h3>{id ? "Edit Asset" : "Create Asset"}</h3>
        </div>

        <Form onSubmit={handleSubmit} className="form-row-card p-3 border rounded bg-white">
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Asset Type <span className="text-danger">*</span></Form.Label>
                <Form.Select name="asset_type" value={formData.asset_type} onChange={handleChange} required>
                  <option value="">Select Asset Type</option>
                  <option value="Vehicles">Vehicles</option>
                  <option value="Land">Land</option>
                  <option value="Furniture & Fixtures">Furniture & Fixtures</option>
                  <option value="Computer">Computer</option>
                  <option value="Hardware">Hardware</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Asset Name <span className="text-danger">*</span></Form.Label>
                <Form.Control name="asset_name" type="text" value={formData.asset_name} onChange={handleChange} required />
              </Form.Group>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control name="asset_description" as="textarea" rows={3} value={formData.asset_description} onChange={handleChange} />
              </Form.Group>
            </div>
          </div>

          <div className="row g-3 mt-2">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Purchase Date</Form.Label>
                <Form.Control name="asset_date" type="date" value={formData.asset_date} onChange={handleChange} />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Amount <span className="text-danger">*</span></Form.Label>
                <Form.Control name="asset_amount" type="number" step="0.01" value={formData.asset_amount} onChange={handleChange} required />
              </Form.Group>
            </div>
          </div>

          <div className="text-end mt-4 d-flex justify-content-end gap-2">
            <Button variant="light" onClick={() => navigate(-1)} disabled={loading}>Cancel</Button>
            <Button type="submit" className="px-4" style={{ backgroundColor: "#5db2e8", border: "none" }} disabled={loading}>
              {loading ? <Spinner size="sm" /> : id ? "Update Asset" : "Create Asset"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default CreateAssets;